/* unplugin-vue-components disabled */import script from "./Progress.vue?vue&type=script&lang=ts&setup=true"
export * from "./Progress.vue?vue&type=script&lang=ts&setup=true"

import "./Progress.vue?vue&type=style&index=0&id=3f5689bd&lang=scss"

const __exports__ = script;

export default __exports__